import { Helmet } from "react-helmet";
import { Button, Img, Input, Heading, Text } from "../../components";
import { useEffect, useState, useRef } from "react";
import OTPInput from "react-otp-input";
import { Navigate, useNavigate, useLocation } from "react-router-dom";
import { API_DOMAIN_IMG, API_DOMAIN } from "config";
import RegistrationPopup from "pages/RegistrationPopup";

export default function SignInDealerPage({ currentUser, setCurrentUser }) {
  const firstInputRef = useRef(null);
  const [formData, setFormData] = useState({ fullName: "", phone: "" });
  const [errors, setErrors] = useState({ fullName: "", phone: "" });
  const [isOtpVisible, setIsOtpVisible] = useState(false);
  const [otp, setOtp] = useState("");
  const [otpSent, setOtpSent] = useState(false);  
  const [sessionId, setSessionId] = useState("");
  const [errorMessage, setErrorMessage] = useState(""); // שדה לשגיאה
  const navigate = useNavigate();
  const [regOpen, setRegOpen] = useState(false);
  const location = useLocation();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    setErrors({ ...errors, [name]: "" });
    setErrorMessage("");
  };

  const validatePhone = (phone) => {
    const phoneRegex =
      /^((\+972|972)|0)5([0|1|2|3|4|5|6|8|9])( |-)?([0-9]{7})$/;
    return phoneRegex.test(phone);
  };


  useEffect(() => {
    if (isOtpVisible) {
      setTimeout(() => {
        const firstOtpInput = document.querySelector(".otp-wrp input");
        if (firstOtpInput) {
          firstOtpInput.focus();
        }
      }, 0);
    }
  }, [isOtpVisible]);

  // Function to send OTP to server
  const sendOtpToServer = async (otpValue) => {
    const form = new FormData();
    form.append("name", formData.fullName.trim());
    form.append("phone", formData.phone.trim());
    form.append("otp", otpValue);
    form.append("session_id", sessionId);

    const response = await fetch(API_DOMAIN + "/otp/verifyOtp", {
      method: "POST",
      credentials: "include",
      body: form,
    });

    const data = await response.json();

    if (data.success) {
      setErrorMessage("");

      const role = Number(data.user_role);

      const user = {
        id: data.user_id,
        name: data.name,
        phone: data.phone,
        user_type: role,
        provider_type: data.provider_type || "company",
      };

      setCurrentUser(user);
      localStorage.setItem("currentUser", JSON.stringify(user));
      localStorage.setItem("userName", data.name || formData.fullName);

      // ✅ אם הגענו מעמוד מוגן – נחזור אליו
      const from = location.state?.from;
      const target = from?.pathname
        ? `${from.pathname}${from.search || ""}`
        : role === 2
        ? "/provider-cars"
        : role === 3
        ? "/dealer-cars"
        : role === 1
        ? "/admin/cars"
        : "/";

      navigate(target, { replace: true });
    } else {
      if (data.code === "USER_INACTIVE") {
        setErrorMessage("המשתמש שלך נחסם, פנה למנהל המערכת");
      } else if (data.code === "INVALID_DETAILS") {
        setErrorMessage("פרטים שגויים");
      } else {
        setErrorMessage("קוד שגוי, נסו שוב");
      }
    }
  };

  const handleSendOTP = async () => {
    setErrorMessage("");
    let newErrors = {};

    if (!formData.fullName.trim()) {
      newErrors.fullName = "שם משתמש הוא שדה חובה";
    }
    if (!formData.phone.trim()) {
      newErrors.phone = "נייד הוא שדה חובה";
    } else if (!validatePhone(formData.phone)) {
      newErrors.phone = "נייד לא תקין";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    const form = new FormData();
    form.append("name", formData.fullName.trim());
    form.append("phone", formData.phone.trim());
    form.append("user_role", 0); // התחברות רגילה

    const response = await fetch(API_DOMAIN + "/otp/sendOtp", {
      method: "POST",
      credentials: "include",
      body: form,
    });

    const data = await response.json();

    if (data.success) {
      setOtpSent(true);
      setSessionId(data.session_id);
      setIsOtpVisible(true);
    } else {
      if (data.code === "USER_NOT_FOUND") {
        setErrorMessage("המספר לא קיים – עברו להרשמה");
      } else if (data.code === "INVALID_DETAILS") {
        setErrorMessage("פרטים שגויים");
      } else if (data.code === "USER_INACTIVE") {
        setErrorMessage("המשתמש שלך נחסם, פנה למנהל המערכת");
      } else if (data.message) {
        setErrorMessage(data.message);
      } else {
        setErrorMessage("שגיאה בשליחת ה-OTP");
      }
    }
  };

  const handleVerifyOTP = async () => {
    sendOtpToServer(otp);
  };

  return (
    <>
      <div className="registration-container">
        <div className="left-section mobile-only-img">
          <Img src="/images/left-img-login.svg" alt="Imageone" />
          <div className="absolute left-0 right-0 top-[8%] mx-auto flex flex-1 flex-col items-start gap-1 pl-[142px] pr-14 lg:pl-8 md:px-5 sm:px-4">
            <Heading
              size="heading15xl"
              as="h1"
              className="!font-montserrat text-[71.43px] font-extrabold !text-red-a700_01 lg:text-[48px] md:text-[48px]"
            ></Heading>
          </div>
        </div>

        <div>
          {!isOtpVisible ? (
            <div className="right-section">
              <div className="wrap-login-form">
                <div className="form-container">
                  <Heading
                    size="heading10xl"
                    as="h2"
                    className="!font-heebo text-[35px] font-bold tracking-[-0.70px] !text-red-a700_03 lg:text-[29px] md:text-[29px] sm:text-[27px]"
                  >
                    התחבר למערכת
                  </Heading>
                  <Heading
                    size="text3xl"
                    as="h3"
                    className="!font-heebo text-[20px] font-medium tracking-[-0.40px] lg:text-[17px] mb-4"
                  >
                    אנא מלאו פרטיכם
                  </Heading>
                  <Heading size="text3xl" as="h3"></Heading>
                </div>

                <div className="mb-[44px] flex flex-col items-center gap-[19px] md:mx-0">
                  <div className="flex flex-col gap-5 mt-8 self-stretch">
                    <div className="flex flex-col gap-0.5">
                      <div className="w-full flex justify-center">
                        <div className="md:w-full w-[420px]">
                          <div className="w-full flex justify-end pr-1">
                            <Text
                              size="h4_assistant16px_r"
                              as="p"
                              className="text-[16px] font-semibold lg:text-[13px]"
                            >
                              <span className="text-red-a700_03">*</span>
                              <span className="text-black-900_03">שם משתמש</span>
                            </Text>
                          </div>
                          <Input
                            size="sm"
                            name="fullName"
                            placeholder="רשמו פה את שמכם המלא"
                            value={formData.fullName}
                            onChange={handleChange}
                            dir="rtl"
                            className={`w-full rounded-[16px] border pr-5 pl-3 !text-right placeholder:!text-right ${
                              errors.fullName ? "border-red-500" : ""
                            }`}
                          />
                        </div>
                      </div>
                      {errors.fullName && (
                        <Text className="text-red-500">{errors.fullName}</Text>
                      )}
                    </div>

                    <div className="flex flex-col gap-0.5">
                      <div className="w-full flex justify-center">
                        <div className="md:w-full w-[420px]">
                          <div className="w-full flex justify-end pr-1">
                            <Heading
                              size="h4_assistant_16px_b"
                              as="h2"
                              className="text-[16px] font-semibold lg:text-[13px]"
                            >
                              <span className="text-red-a700_03">*</span>
                              <span className="text-black-900_03">נייד</span>
                            </Heading>
                          </div>
                          <Input
                            size="sm"
                            type="text"
                            name="phone"
                            placeholder="רשמו פה את מספר הנייד"
                            value={formData.phone}
                            onChange={handleChange}
                            dir="rtl"
                            className={`w-full rounded-[16px] border pr-5 pl-3 !text-right placeholder:!text-right ${
                              errors.phone ? "border-red-500" : ""
                            }`}
                          />
                        </div>
                      </div>
                      {errors.phone && (
                        <Text className="text-red-500">{errors.phone}</Text>
                      )}
                    </div>
                  </div>

                  {/* הודעת שגיאה כללית – מקום קבוע */}
                  <div className="mt-3 h-6 flex items-center justify-center">
                    {errorMessage && (
                      <Text className="text-center text-red-600 text-sm leading-none">
                        {errorMessage}
                      </Text>
                    )}
                  </div>

                  <div className="flex w-[24%] justify-center lg:w-full md:w-full">
                    <div className="w-full">
                      <Button
                        onClick={handleSendOTP}
                        leftIcon={
                          <div className="flex h-[10px] w-[6px] items-center justify-center">
                            <Img
                              src="images/img_arrowleft.svg"
                              alt="Arrow Left"
                              className="mt-0.5 h-[10px] w-[6px] object-contain"
                            />
                          </div>
                        }
                        className="h-[40px] w-full gap-2 black-over rounded-[20px] bg-red-800 px-2.5 text-[16px] font-semibold text-secondary-primary_white lg:text-[13px]"
                      >
                        קבל קוד
                      </Button>
                    </div>
                  </div>

                  <Heading
                    as="a"
                    size="textmd"
                    onClick={() => setRegOpen(true)}
                    className="mt-2 text-center cursor-pointer !font-heebo text-[14px] font-normal !text-blue-600 underline"
                  >
                    אין חשבון? הרשמה
                  </Heading>
                </div>
              </div>
            </div>
          ) : (
            <div className="right-section">
              <div className="wrap-login-form">
                <div className="form-container">
                  <Heading
                    size="heading10xl"
                    as="h2"
                    className="!font-heebo text-[35px] font-bold tracking-[-0.70px] !text-red-a700_03 lg:text-[29px] md:text-[29px] sm:text-[27px]"
                  >
                   SMS קבלת 
                  </Heading>
                  <Heading
                    size="text3xl"
                    as="h3"
                    className="!font-heebo text-[20px] font-medium tracking-[-0.40px] lg:text-[17px] mb-4"
                  >
                    אנא הזינו את הקוד
                  </Heading>
                </div>

                <div className="mb-[44px] flex flex-col items-center gap-[19px] md:mx-0">
                  <div className="flex flex-col gap-5 mt-8 self-stretch">
                    <div className="flex flex-col gap-0.5">
                      <div className="w-full flex justify-center">
                        <div className="md:w-full w-[420px]">
                          <div className="w-full flex justify-end pr-1">
                            <Text
                              size="h4_assistant16px_r"
                              as="p"
                              className="text-[16px] font-semibold lg:text-[13px]"
                            >
                              <span className="text-red-a700_03">*</span>
                              <span className="text-black-900_03">קוד</span>
                            </Text>
                          </div>
                          <div className="otp-wrp flex justify-center mt-2">
                            <OTPInput
                              value={otp}
                              onChange={setOtp}
                              numInputs={6}
                              renderSeparator={
                                <span style={{ pointerEvents: "none" }}>-</span>
                              }
                              renderInput={(inputProps, index) => (
                                <input
                                  {...inputProps}
                                  key={index}
                                  inputMode="numeric"
                                  autoComplete={index === 0 ? "one-time-code" : "off"}
                                  pattern="\d*"
                                  style={{
                                    height: "50px",
                                    width: "50px",
                                    border: "1px solid #b0b7c3",
                                    borderRadius: "3px",
                                    textAlign: "center",
                                    fontSize: "16px",
                                  }}
                                />
                              )}
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="mt-3 h-6 flex items-center justify-center">
                    {errorMessage && (
                      <Text className="text-center text-red-600 text-sm leading-none">
                        {errorMessage}
                      </Text>
                    )}
                  </div>

                  <div className="flex w-[24%] justify-center lg:w-full md:w-full">
                    <div className="w-full">
                      <Button
                        onClick={handleVerifyOTP}
                        leftIcon={
                          <div className="flex h-[10px] w-[6px] items-center justify-center">
                            <Img
                              src="images/img_arrowleft.svg"
                              alt="Arrow Left"
                              className="mt-0.5 h-[10px] w-[6px] object-contain"
                            />
                          </div>
                        }
                        className="h-[40px] w-full gap-2 black-over rounded-[20px] bg-red-800 px-2.5 text-[16px] font-semibold text-secondary-primary_white lg:text-[13px]"
                      >
                        כניסה לממשק
                      </Button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>

      {regOpen && (
        <RegistrationPopup
          onClose={() => setRegOpen(false)}
          //  onSuccess={finaliseLogin}      // אותה פונקציה שמכניסה את המשתמש למערכת
        />
      )}
    </>
  );
}
